/**
 * Reads a project's location / VPN refusal (backend `ip_access`) out of a failed
 * collection-flow call. Any other failure — including another 403 — is `null`
 * and keeps the generic error screen.
 */
import { CollectionFlowError } from './client';

export type AccessRefusal =
  | { kind: 'location'; countryCode: string; country: string; region: string }
  | { kind: 'vpn' };

/** The refusal an error carries, or `null` for any other failure. */
export function accessRefusal(error: unknown): AccessRefusal | null {
  if (!(error instanceof CollectionFlowError) || error.status !== 403) return null;
  if (error.code === 'vpn_not_allowed') return { kind: 'vpn' };
  if (error.code !== 'location_not_allowed') return null;
  const text = (key: string) =>
    typeof error.details?.[key] === 'string' ? (error.details[key] as string) : '';
  return {
    kind: 'location',
    countryCode: text('country_code'),
    country: text('country'),
    region: text('region'),
  };
}
